import { dbuiV1GetNotableByIdOptions } from '@antimatterhq/asl-api-ts-v1';
import { useQuery } from '@antimatterhq/ui/hooks/queries/useQuery';
import { useWorkspace } from '@/contexts/WorkspaceContext';
import { useWarehouseLocation } from '@/contexts/WarehouseLocationContext';
import { defaultOptions } from '@/utils/query';
export const useGetNotableById = (id: string) => {
  const { workspace } = useWorkspace();
  const { selectedWarehouse } = useWarehouseLocation();

  return useQuery({
    ...dbuiV1GetNotableByIdOptions({
      ...defaultOptions(),
      path: { workspace, id },
      query: { warehouse: selectedWarehouse?.id || '' },
    }),
    enabled: !!workspace && !!selectedWarehouse?.id && !!id,
  });
};
